<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>
      <div style="font-size: 20px;">{{ storeName }}</div>
      <div style="height: 30px;"></div>
      <v-text-field v-model="stocktakingMonth" label="棚卸年月" prepend-icon="event" box readonly></v-text-field>
      <div style="height: 30px;"></div>

      <v-card>
        <v-container>
          <v-card-title class="title-highlight">
            棚卸在庫
          </v-card-title>

          <!-- <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                label="ファイル"
                @click="pickFile"
                v-model="fileName"
                prepend-icon="attach_file"
                hint="CSVファイル"
                v-validate="'required'"
              ></v-text-field>
              <input
                type="file"
                ref="file"
                style="display: none"
                accept=".csv, .xls"
                @change="onFileChange($event)"
              />
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs6 class="pr-2">
              <v-btn block color="success" dark :loading="loading1" @click="fileUpload()">
                <v-icon dark left>cloud_upload</v-icon>アップロード
              </v-btn>
            </v-flex>

            <v-flex xs6 class="pl-2">
              <v-btn block color="primary" dark @click="downloadCsv()">
                <v-icon dark left>get_app</v-icon>ダウンロード
              </v-btn>
            </v-flex>
          </v-layout>

          <div style="height: 30px;"></div> -->

          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="JANコード検索"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>

            <div style="height: 35px;"></div>

            <v-data-table
              :headers="headers"
              :items="stocktakingItems"
              hide-actions
              class="elevation-1"
              style="width: 100%;    margin: 15px 0 0;"
              :search="search"
              :customFilter="customFilter"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <template v-slot:items="props">
                <tr              
                  v-bind:class="{
                    'deleted-class-name': props.item.isDeleted == '1' ? true : false               
                  }"
                >
                  <td class="text-xs-left" width="30px">{{ props.item.janCode }}</td>
                  <td class="text-xs-left">{{ props.item.itemName }}</td>
                  <td class="text-xs-center item-num-column" width="50px">
                    <input
                      type="number"
                      name="itemNum[]"
                      v-model="props.item.stockQuantity"
                      class="column-input-for-stock"
                      min="0"
                      value="0"
                    />
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 25px;"></div>

      <!-- 버튼 영역 -->
      <div class="footer-btns">
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/stockManagement' }">
          <v-icon dark left>arrow_back</v-icon>
          {{ $t('back-btn') }}
        </v-btn>
        <v-btn block color="success" dark @click="registStocktakingByAdmin()">
            <v-icon dark left>save</v-icon>登録する
          </v-btn>  
      </div>
    </v-container>

  </v-form>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'
import moment from 'moment-timezone'

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    this.storeName = this.$route.params.storeName
    this.stocktakingMonth = moment(
      this.$route.params.stocktakingMonth,
      'YYYY-MM-DD'
    ).format('YYYY/MM')    

    this.getStocktakingItemsByAdmin()
  },
  methods: {
    customFilter(items, search) {
      console.log('custom filter')

      if (!search) {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.janCode.includes(search)) {
            return true
          } else {
            return false
          }
        })
        return filteringItems
      }
    },
    getStocktakingItemsByAdmin() {
      console.log('getStocktakingItemsByAdmin')
      let thisObj = this

      let request = {
        stocktakingMonth: this.$route.params.stocktakingMonth,
        storeCode: this.$route.params.storeCode
      }

      ServerApiCallService.getStocktakingItemsByAdmin(request)
        .then(response => {
          
          this.stocktakingItems = response.data.items.map(item => ({
          ...item,
          stockQuantity:
            item.stockQuantity === null || item.stockQuantity === undefined
              ? 0
              : item.stockQuantity
        }))

        // 商品の表示順 商品カテゴリ、商品名
        thisObj.stocktakingItems.sort(function(a, b) {
          if (a.itemName > b.itemName) return 1
          if (a.itemName < b.itemName) return -1
          // a must be equal to b
          return 0
        })
        thisObj.stocktakingItems.sort(function(a, b) {
          if (a.itemCategoryId > b.itemCategoryId) return 1
          if (a.itemCategoryId < b.itemCategoryId) return -1
          // a must be equal to b
          return 0
        })
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
    },
    registStocktakingByAdmin() {
      console.log('registStocktakingByAdmin')

      let request = {
        stocktakingMonth: this.$route.params.stocktakingMonth,
        storeCode: this.$route.params.storeCode,
        stocktakingItems: this.stocktakingItems
      }

      console.log("request: ", request);
      

      ServerApiCallService.registStocktakingByAdmin(request)
        .then(response => {
          this.$router.push({
            name: 'admin/stockManagement',
            params: {}
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    pickFile() {
      this.$refs.file.click()
    },
    onFileChange(e) {
      // const files = e.target.files
      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }
    },
    fileUpload() {
      console.log('fileUpload')
      let thisObj = this
      
      // FormData を利用して File を POST する
      let formData = new FormData()
      formData.append('uploadFile', this.targetFile)
      formData.append('charsetName', this.fileFormat)
      formData.append('storeCode', this.$route.params.storeCode)
      formData.append('stocktakingMonth', this.$route.params.stocktakingMonth)

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }
      })

      thisObj.loading1 = true      
      ServerApiCallService.sendStoreStocktakingSaveFile(formData, sendContext)
        .then(response => {
          // 버튼의 빙글빙글 돌게 하는거
          thisObj.loading1 = false          
          
          this.getStocktakingItemsByAdmin()
        })
        .catch(error => {
          thisObj.loading1 = false
        })
    },
    downloadCsv() {
      let request = {
        storeCode: this.$route.params.storeCode,
        stocktakingMonth: this.$route.params.stocktakingMonth,
      }

      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken')
          }
        })
        .post('/admin/store-stocktaking-save-download', request, {
          responseType: 'blob',
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.$route.params.storeName + '_在庫棚卸.csv'
          link.click()
        })
    },
  },
  data() {
    return {
      loading1: false,
      fileName: '',
      fileFormat: 'SHIFT-JIS',
      storeName: '',
      stocktakingMonth: '',
      search: '',
      stocktakingItems: [],
      
      headers: [
        {
          text: 'JanCode',
          align: 'left',
          value: 'janCode',
          sortable: false,
          fixed: false
        },
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false
        },
        {
          text: '物理在庫数',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true
        }
      ]
    }
  }
}
</script>

<style>
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
.column-input-for-stock {
  width: 55px !important;
  height: 40px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
  font-size: 16px;
}
.item-num-column {
  /* width: 50px !important; */
  padding: 0 10px !important;
  font-size: 16px !important;
}
.deleted-class-name {
  background-color: #b3b3b3;
}
</style>
